<template>
  <section class="security-standards">
    <div class="container">
      <h1 class="section-title">🛡 Padrões de Segurança Infantil</h1>
      <p class="intro-text">
        O <strong>Meu Queridômetro</strong> está comprometido com a prevenção do abuso e exploração sexual infantil (CSAE) e adota medidas rigorosas para manter um ambiente seguro para todos os usuários.
      </p>

      <div class="security-section">
        <h2>📌 Compromisso</h2>
        <p>
          Nosso app segue integralmente as leis brasileiras e internacionais de proteção infantil. Temos tolerância zero para qualquer forma de exploração, abuso ou assédio infantil.
        </p>
      </div>

      <div class="security-section">
        <h2>🛠 Medidas de Prevenção</h2>
        <ul>
          <li>❌ Proibição explícita de conteúdo impróprio, ofensivo ou sexual.</li>
          <li>🚨 Botão de denúncia disponível em todas as interações no app.</li>
          <li>🧠 Moderação automatizada com inteligência artificial e revisão humana.</li>
          <li>🔒 Perfis e interações protegidas com regras de privacidade e consentimento mútuo.</li>
        </ul>
      </div>

      <div class="security-section">
        <h2>📨 Denúncias</h2>
        <p>
          Todos os relatos envolvendo CSAE são avaliados com prioridade máxima e encaminhados às autoridades competentes, como o <a href="https://www.gov.br/mdh/pt-br/assuntos/crianca-e-adolescente/disque-direitos-humanos" target="_blank">Disque 100</a> no Brasil.
        </p>
      </div>

      <div class="security-section">
        <h2>📧 Contato Direto</h2>
        <p>
          Para qualquer dúvida ou solicitação relacionada à segurança infantil no aplicativo, entre em contato com nosso responsável designado:
        </p>
        <ul>
          <li><strong>Email:</strong> <a href="mailto:aleappdev@gmail.com">aleappdev@gmail.com
          </a></li>
        </ul>
      </div>

      <div class="security-section">
        <h2>✅ Conformidade</h2>
        <p>
          Estamos em conformidade com a <strong>Política de padrões de segurança infantil</strong> da Google Play, incluindo práticas de denúncia, moderação e responsabilidade jurídica.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PadroesSeguracaMeuQueridometro'
}
</script>

<style scoped>
.security-standards {
  padding: 3rem 1.5rem;
  background: #fdf4ff;
  color: #4a148c;
  font-family: 'Arial', sans-serif;
}

.container {
  max-width: 960px;
  margin: 0 auto;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 2rem;
  color: #6a1b9a;
}

.intro-text {
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 2.5rem;
  color: #5e35b1;
}

.security-section {
  margin-bottom: 2.5rem;
}

.security-section h2 {
  font-size: 1.6rem;
  margin-bottom: 0.8rem;
  color: #ab47bc;
}

.security-section ul {
  padding-left: 1.5rem;
  list-style-type: disc;
  color: #4a148c;
}

.security-section a {
  color: #8e24aa;
  text-decoration: underline;
}

.security-section a:hover {
  text-decoration: none;
}

.game-card {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    text-decoration: none;
    color: #333;
    transition: transform 0.3s;
  }
  
  .game-card:hover {
    transform: translateY(-5px);
  }
  
  .game-card h2 {
    color: #4CAF50;
    margin-bottom: 10px;
  }


</style>
